import * as React from 'react'
import Calendar from 'react-calendar'
import './Datepicker.css'
import { StyledInput, StyledInputIcon, StyledWrapper, StyledWrapperCalendar, StyledBlock } from './Datepicker.style'
import { ClickOutside } from '../ClickOutside'

interface Props extends React.InputHTMLAttributes<any> {
  isOpened?: boolean
  onDateChange: (date: Date) => void
  width?: number
  initialValue?: string
}

interface State {
  contentIsVisible: boolean
  date: Date
}

export class Datepicker extends React.Component<Props, State> {
  private calendarRef = React.createRef<HTMLDivElement>()

  state = { contentIsVisible: false, date: null }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.hideContent()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
    if (this.props.initialValue) {
      this.setState({ date: new Date(this.props.initialValue) })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    const { contentIsVisible } = this.state

    return (
      <ClickOutside onClickOutside={this.hideContent}>
        <StyledBlock width={this.props.width}>
          <StyledWrapper>
            <StyledInput
              onClick={this.handleClickReference}
              className="Datepicker-input"
              value={this.getDate()}
              readOnly
              placeholder={this.props.placeholder}
              isOpened={this.state.contentIsVisible}
            />
            <StyledInputIcon />
          </StyledWrapper>
          {contentIsVisible && (
            <StyledWrapperCalendar innerRef={this.calendarRef}>
              <Calendar
                className="Datepicker-calendar"
                value={this.state.date}
                onChange={this.onChange}
                minDate={new Date()}
              />
            </StyledWrapperCalendar>
          )}
        </StyledBlock>
      </ClickOutside>
    )
  }

  private getYear = () => this.state.date.getFullYear()

  private getMonth = () => this.state.date.toLocaleString('es-ES', { month: 'long' })

  private getDay = () => this.state.date.getDate()

  private getDate = () => {
    if (this.state.date !== null) {
      return `${this.getDay()} ${this.getMonth()} de ${this.getYear()}`
    }
    return undefined
  }

  private onChange = date => {
    this.setState({ date })
    this.props.onDateChange(date)
    this.handleClickReference()
  }

  private handleClickReference = () => {
    if (this.state.contentIsVisible) {
      this.hideContent()
    } else {
      this.showContent()
    }
  }

  private hideContent = () => {
    this.setState({ contentIsVisible: false })
  }

  private showContent = () => {
    this.setState({ contentIsVisible: true })
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Datepicker/Datepicker.tsx